import { Box, Stack } from '@mui/material';
import React, { ReactNode } from 'react';

type TwoColumnLayoutProps = {
  leftColumn: ReactNode[];
  rightColumn: ReactNode[];
};

export function TwoColumnLayout({
  leftColumn,
  rightColumn,
}: TwoColumnLayoutProps): React.JSX.Element {
  return (
    <>
      <Box flex={1} minWidth={0}>
        <Stack spacing={3}>
          {leftColumn.map((child, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>{child}</React.Fragment>
          ))}
        </Stack>
      </Box>
      <Box flex={1} minWidth={0}>
        <Stack spacing={3}>
          {rightColumn.map((child, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <React.Fragment key={index}>{child}</React.Fragment>
          ))}
        </Stack>
      </Box>
    </>
  );
}
